import { PropsWithChildren, useCallback, useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import cx from 'classnames';
import arrowLightDown from 'assets/icons/arrow_light_down.svg';
import { AccordionProps } from './Accordion.types';

const Accordion: React.FC<PropsWithChildren<AccordionProps>> = ({
  children,
  dataTestId,
  label,
  onOpen,
  onClose,
  isDisabled = false,
  isOpenOnInit = true,
  isExternalOpen,
  icon,
  extendedChildren,
  hasBorder = false,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenOnInit);

  useEffect(() => {
    setIsOpen(isOpenOnInit);
  }, [isOpenOnInit]);

  const handleClick = useCallback(() => {
    if (isExternalOpen ?? isOpen) {
      onClose?.();
    } else {
      onOpen?.();
    }

    setIsOpen(!isOpen);
  }, [isOpen, isExternalOpen]);

  const toggleIcon = (
    <SVG
      className={cx('fill-current w-4 h-4 text-neutral-900', { 'rotate-180': isExternalOpen ?? isOpen })}
      src={arrowLightDown}
    />
  );

  return (
    <div
      data-test-id={dataTestId}
      className={cx({
        'border-b pb-2': hasBorder,
      })}
    >
      <button
        type="button"
        onClick={handleClick}
        disabled={isDisabled}
        className="w-full flex items-center sub-header-base py-0 justify-between"
      >
        <div className="flex gap-1 items-center text-essential-tertiary body-sm">
          {!!icon && <SVG className="w-4 h-4" src={icon} />}
          {label}
        </div>
        {extendedChildren}
        {toggleIcon}
      </button>
      {(isExternalOpen ?? isOpen) && children}
    </div>
  );
};

export default Accordion;
